import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (id: ID) => {
  return {
    endpoint: `/labels/${id}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
